/* AII — Richiesta di pubblicazione convenzione.
   Form nativo multipart verso FormSubmit: necessario affinché PDF/immagini arrivino come allegati.
   I file sono solo richieste di revisione: questo script non pubblica né carica contenuti nello showroom. */
(function () {
  'use strict';
  var MAX_TOTAL_BYTES = 10 * 1024 * 1024;
  var ALLOWED_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/webp'];

  function init(root) {
    if (!root || root.dataset.aiiConvenzioniReady === '1') return;
    root.dataset.aiiConvenzioniReady = '1';
    var open = root.querySelector('[data-aii-convenzioni-open]');
    var close = root.querySelector('[data-aii-convenzioni-close]');
    var wrap = root.querySelector('[data-aii-convenzioni-form-wrap]');
    var form = root.querySelector('[data-aii-convenzioni-form]');
    var files = root.querySelector('[data-aii-convenzioni-files]');
    var error = root.querySelector('[data-aii-convenzioni-files-error]');
    var iframe = root.querySelector('[data-aii-convenzioni-iframe]');
    var success = root.querySelector('[data-aii-convenzioni-success]');
    var submitted = false;
    if (!open || !wrap || !form || !files) return;

    function setError(message) {
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
      if (message) files.setAttribute('aria-invalid', 'true');
      else files.removeAttribute('aria-invalid');
    }
    function validateFiles() {
      var selected = Array.prototype.slice.call(files.files || []);
      var total = selected.reduce(function (sum, file) { return sum + file.size; }, 0);
      if (!selected.length) { setError('Allega almeno un file.'); return false; }
      if (selected.some(function (file) { return ALLOWED_TYPES.indexOf(file.type) === -1; })) { setError('Sono ammessi solo PDF, PNG, JPG o WebP.'); return false; }
      if (total > MAX_TOTAL_BYTES) { setError('La dimensione totale degli allegati non può superare 10 MB.'); return false; }
      setError('');
      return true;
    }
    function show() {
      wrap.hidden = false;
      open.setAttribute('aria-expanded', 'true');
      files.focus({ preventScroll: true });
    }
    function hide() {
      wrap.hidden = true;
      open.setAttribute('aria-expanded', 'false');
      open.focus({ preventScroll: true });
    }
    open.addEventListener('click', show);
    if (close) close.addEventListener('click', hide);
    files.addEventListener('change', validateFiles);
    form.addEventListener('submit', function (event) {
      if (!validateFiles()) { event.preventDefault(); files.focus({ preventScroll: true }); return; }
      submitted = true;
    });
    if (iframe) iframe.addEventListener('load', function () {
      if (!submitted) return;
      submitted = false;
      form.hidden = true;
      if (success) { success.hidden = false; success.focus({ preventScroll: true }); }
    });
  }
  function boot() { document.querySelectorAll('[data-aii-convenzioni]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
